import styled from 'styled-components';

export const StyledDashboard = styled.div`
  background: white;
  margin: 20px;
  padding: 30px;
`;
